"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../helpers/create-event-accessor"),
    setupForSimpleEventAccessors = _require.setupForSimpleEventAccessors;

var EventTargetImpl = require("../events/EventTarget-impl").implementation;

var Event = require("../generated/Event");

var AbortSignalImpl =
/*#__PURE__*/
function (_EventTargetImpl) {
  _inherits(AbortSignalImpl, _EventTargetImpl);

  function AbortSignalImpl(args, privateData) {
    var _this;

    _classCallCheck(this, AbortSignalImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbortSignalImpl).call(this)); // make event firing possible

    _this._ownerDocument = privateData.window.document;
    _this.aborted = false;
    _this.abortAlgorithms = new Set();
    return _this;
  }

  _createClass(AbortSignalImpl, [{
    key: "_signalAbort",
    value: function _signalAbort() {
      if (this.aborted) {
        return;
      }

      this.aborted = true;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.abortAlgorithms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var algorithm = _step.value;
          algorithm();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.abortAlgorithms.clear();

      this._dispatch(Event.createImpl(["abort", {
        bubbles: false,
        cancelable: false
      }], {
        isTrusted: true
      }));
    }
  }, {
    key: "_addAlgorithm",
    value: function _addAlgorithm(algorithm) {
      if (this.aborted) {
        return;
      }

      this.abortAlgorithms.add(algorithm);
    }
  }, {
    key: "_removeAlgorithm",
    value: function _removeAlgorithm(algorithm) {
      this.abortAlgorithms.delete(algorithm);
    }
  }]);

  return AbortSignalImpl;
}(EventTargetImpl);

setupForSimpleEventAccessors(AbortSignalImpl.prototype, ["abort"]);
module.exports = {
  implementation: AbortSignalImpl
};